/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import { Typography, TypographyProps } from "@mui/material";
import StyleguideView from "@/src/styleguide/components/StyleguideView/StyleguideView.tsx";

export default function TypographyStyleguide(){
  return (
    [
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "subtitle1",
      "subtitle2",
      "body1",
      "body2",
      "body3",
      "button",
      "caption",
      "overline",
      "cardTitle",
    ] as (NonNullable<TypographyProps["variant"]>)[]
  ).map((variant) => {
    return (
      <StyleguideView key={variant} title={variant[0].toUpperCase() + variant.slice(1)}>
        <Typography variant={variant}>Lorem ipsum dolor sit</Typography>
      </StyleguideView>
    );
  });
};
